import React from 'react';
import {Route, Switch} from 'react-router-dom';
import asyncComponent from '../../../util/asyncComponent';
import {useSelector} from "react-redux";
import {isCurrentUserMemberOf} from "../../../util/bbHelpers";

function PartnerPageRoutes({match}) {
    return(
        <Switch>
            {/*<Redirect exact from={`${match.url}`} to={`${match.url}`}/>*/}
            {/*<Route path={`${match.url}/ASA`} component={asyncComponent(() => import('../../../../Archive/ASA'))}/>*/}
            {/*<Route path={`${match.url}/Quicklook`} component={asyncComponent(() => import('../../../../Archive/Quicklook'))}/>*/}
            <Route path={`${match.url}/Network`} component={asyncComponent(() => import('./routes/ClientNetwork'))}/>


            <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
        </Switch>
    );
}

const PartnerPages = ({match}) => {
    const authUser = useSelector(({auth}) => auth.authUser);
    if (isCurrentUserMemberOf(authUser, "partner") || isCurrentUserMemberOf(authUser, "admin")) {
        return (
                <PartnerPageRoutes match={match}/>
        )
    } else {
        return (
            <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
        )
    }
};

export default PartnerPages;
